// src/hooks/useTrueViewportHeight.ts
import { useEffect } from 'react';

// This function measures the window's inner height and sets it as a CSS variable.
const setTrueViewportHeight = () => {
  // We calculate 1% of the window's inner height to create our own 'vh' unit.
  const vh = window.innerHeight * 0.01;
  // We set this value on the root HTML element in a CSS custom property called `--vh`.
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};

export const useTrueViewportHeight = () => {
  useEffect(() => {
    // Set the value on initial component mount.
    setTrueViewportHeight();

    // Add a listener to update the value whenever the window is resized.
    window.addEventListener('resize', setTrueViewportHeight);

    // Cleanup: remove the listener when the component unmounts.
    return () => {
      window.removeEventListener('resize', setTrueViewportHeight);
    };
  }, []); // The empty dependency array ensures this runs only on mount and unmount.
};